/* eslint-disable max-len */
import {
  AfterContentInit,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { NzModalService } from 'ng-zorro-antd/modal';

import {
  ErrorsHandlingService,
  AuthService,
  ViewerRestrictionService
} from './../../../../core/services';
import {
  AppOptions,
  HelpersInterface,
} from './../../../../core/interfaces';
import { PartnerInterfaceGlobal, CompanyInterface } from './../../../../core/models';
import { ConnectionTypeEnum, UserRole } from './../../../../core/enum';
import { AppConfig } from './../../../../core/configs';

import { EditSspDialogComponent } from '../../modals';
import { MainService, MainTableService } from '../../services';
import { MainDashboardInterface, sortableSSPTableColumns } from '../../models';

const slideInOut = trigger('slideInOut', [
  state('void', style({ height: '0px' })),
  state('*', style({ height: '*' })),
  transition('void => *', animate('500ms ease-in')),
  transition('* => void', animate('500ms ease-out'))
]);

const toggleInOut = trigger('toggleInOut', [
  state('void', style({ height: '0px' })),
  state('*', style({ height: '*' })),
  transition('* => void', animate('300ms ease-in')),
  transition('void => *', animate('300ms ease-out')),
]);

const toggleArrow = trigger('toggleArrow', [
  state('none', style({ transform: 'rotate(0)' })),
  state('visible', style({ transform: 'rotate(90deg)' })),
  transition('visible => none', animate('300ms ease-in')),
  transition('none => visible', animate('300ms ease-out')),
]);


@Component({
  selector: 'app-main-table-ssp',
  templateUrl: './main-table-ssp.component.html',
  styleUrls: ['./main-table-ssp.component.scss'],
  animations: [slideInOut, toggleInOut, toggleArrow],
  standalone: false
})
export class MainTableSspComponent implements OnInit, AfterContentInit, DoCheck {

  @Input() public companies: CompanyInterface.ICompany[];

  @Input() public set dataCompanies(value: MainDashboardInterface.ICompaniesDataForMainTable[]) {
    this._dataCompanies = value;
  }

  public get dataCompanies(): MainDashboardInterface.ICompaniesDataForMainTable[] {
    return this._dataCompanies;
  }

  @Input() public set dataEndpoints(value: MainDashboardInterface.IEndpointsDataForMainTable[]) {
    this._dataEndpoints = value;
  }

  public get dataEndpoints(): MainDashboardInterface.IEndpointsDataForMainTable[] {
    return this._dataEndpoints;
  }
  @Input() public options: AppOptions;
  @Input() public type: string;
  @Input() public paginationState: {
    current_page: number;
    per_page: number;
    total: number;
  };
  @Input() public filterLists: HelpersInterface.IFilterListsItems[];
  @Input() public supply: boolean;
  @Input() public activity: number | string;
  @Input() public showEndpoint: boolean;
  @Input() public userRole: UserRole;
  @Input() public allCompanies: CompanyInterface.ICompany[];

  @Input() public set partnerSettings(value: PartnerInterfaceGlobal.IPartnerSettings | PartnerInterfaceGlobal.IPartnerGeneral) {
    this._partnerSettings = value;
  }

  public get partnerSettings(): PartnerInterfaceGlobal.IPartnerSettings | PartnerInterfaceGlobal.IPartnerGeneral {
    return this._partnerSettings;
  }

  @Input() public set companiesDSPForDropdown(value: HelpersInterface.ITressSelectItem[]) {
    this._companiesDSPForDropdown = value;
  }

  public get companiesDSPForDropdown(): HelpersInterface.ITressSelectItem[] {
    return this._companiesDSPForDropdown;
  }

  @Input() public set sspSpinnerStatus(value: boolean) {
    this._sspSpinnerStatus = value;
  }

  public get sspSpinnerStatus(): boolean {
    return this._sspSpinnerStatus;
  }

  @Output() public sortTable = new EventEmitter<{ sortBy: string; sortOrder: string; }>();
  @Output() public heightTable = new EventEmitter();
  @Output() public changePage = new EventEmitter();
  @Output() public updateSSP = new EventEmitter<string>();
  @Output() public duplicatedEndpoint = new EventEmitter<{ endpointId: any; side: string; }>();
  @Output() public deleteEndpoint = new EventEmitter<{ endpointId: any; side: string; companyId?: number }>();
  @Output() public activateCompany = new EventEmitter<{ side: string }>();
  @Output() public updateEndpointActiveStatus = new EventEmitter<{ side: string; type: string }>();

  protected tableHeight = 'auto';
  protected companiesState: { [key: string]: boolean } = {};

  protected connectionTypes = ConnectionTypeEnum;
  protected placeholderMarginTop = 'auto';

  private tbodyHeight: number;
  private sortableColumns: string[] = sortableSSPTableColumns;

  private _companiesDSPForDropdown: HelpersInterface.ITressSelectItem[] = [];
  private _sspSpinnerStatus = true;

  private panelIsCollapsed = false;

  private _partnerSettings: PartnerInterfaceGlobal.IPartnerSettings | PartnerInterfaceGlobal.IPartnerGeneral;

  private _dataCompanies: MainDashboardInterface.ICompaniesDataForMainTable[] = [];
  private _dataEndpoints: MainDashboardInterface.IEndpointsDataForMainTable[] = [];

  constructor(
    protected mainTableService: MainTableService,
    protected currencyPipe: CurrencyPipe,
    protected decimalPipe: DecimalPipe,
    private modalService: NzModalService,
    private authService: AuthService,
    private errorsHandlingService: ErrorsHandlingService,
    private mainService: MainService,
    private viewerRestrictionService: ViewerRestrictionService,
    private initConfig: AppConfig,
  ) { }

  public ngOnInit(): void {
    this.initConfig.isCollapsed$.subscribe((value) => {
      this.panelIsCollapsed = value;
    });
  }

  public ngDoCheck(): void {
    const element = document.getElementById('ssp-spinner');
    if (element) {
      const rect = element.getBoundingClientRect();
      this.placeholderMarginTop = rect.top / 2 + 75 + 'px';
    }

    if (!this.panelIsCollapsed && window.innerWidth < 1367) {
      this.tableHeight = window.innerHeight - 560 + 'px';
    } else {
      this.tableHeight = window.innerHeight - 500 + 'px';
    }
  }

  public ngAfterContentInit() {
    this.tableHeight = window.innerHeight - 500 + 'px';
    this.tbodyHeight = window.innerHeight - 209;
    this.heightTable.emit(this.tbodyHeight);
    window.addEventListener('resize', () => {
      this.tableHeight = window.innerHeight - 500 + 'px';
      this.tbodyHeight = window.innerHeight - 209;
      this.heightTable.emit(this.tbodyHeight);
    });
  }

  protected isDisabledOpenModalBtn(item: MainDashboardInterface.IEndpointsDataForMainTable): boolean {
    const restrictionConnectionTypes = [4, 5];
    return this.partnerSettings?.partner_plan === 3 && restrictionConnectionTypes.includes(item.connectionType);
  }

  protected tooltipForOpenModalBtn(item: MainDashboardInterface.IEndpointsDataForMainTable): string {
    const restrictionConnectionTypes = [4, 5];
    return this.partnerSettings?.partner_plan === 3 && restrictionConnectionTypes.includes(item.connectionType)
      ? 'The endpoint is not available for editing because your current plan no longer supports the connection type of this endpoint. If you want to upgrade your platform, please contact our Business Development Manager.'
      : `${item.name}`;
  }

  protected get colSpanNumbers(): number {
    return this.options.ssp.filter(option => option.active).length + 4;
  }

  protected isDisabledSwitch(endpoint: MainDashboardInterface.IEndpointsDataForMainTable): boolean {
    const restrictionConnectionTypes = [4, 5];
    if (this.partnerSettings?.partner_plan === 3 && restrictionConnectionTypes.includes(endpoint.connectionType)) {
      return true;
    } else {
      return this.userRole === UserRole.viewer || !!endpoint.deletedAt;
    }
  }

  protected getMargin(endpoint: MainDashboardInterface.IEndpointsDataForMainTable): number | string | void {
    return this.mainTableService.getMarginByTypeHandler(endpoint);
  }

  protected isOptionActive(attr: string, side: string): boolean {
    return this.mainTableService.isOptionActiveHandler(attr, side, this.options);
  }

  protected isClosed(i: number): 'none' | 'visible' {
    return this.mainTableService.isClosedCompanyHandler(i, this.companiesState);
  }

  protected sort(sortBy: string): void {
    const sortState = this.mainTableService.onSortSSPTable(sortBy, this.sortableColumns);

    if (sortState) {
      this.sortTable.emit(sortState);
    }
  }

  protected toggleCompanyState(i: number) {
    this.companiesState[i] = !this.companiesState[i];
  }

  protected openSspEditModal(endpointId: number, companyId: number) {
    const partnerSettings = this.authService.partner;
    const dialogRef = this.modalService.create({
      nzContent: EditSspDialogComponent,
      nzMaskClosable: false,
      nzClassName: 'endpoint-edit-modal',
      nzWrapClassName: 'endpoint-edit-modal-wrap',
      nzStyle: { top: '100px', width: '850px', overflow: 'hidden', },
      nzBodyStyle: { width: '850px', padding: '0', height: '580px', overflowY: 'scroll' },
      nzClosable: false,
      nzFooter: null,
      nzTitle: '',
      nzData: {
        endpointId: endpointId,
        companyId: companyId,
        partnerSettings: partnerSettings,
        companies: this.allCompanies,
        userRole: this.userRole,
        filterLists: this.filterLists,
      }
    });

    dialogRef.afterClose.subscribe(res => {
      this.updateSSP.emit(res);
    });
  }

  protected onUpdateSSP(data: { status: string; companyId: number; }): void {
    this.companiesState[data.companyId] = !this.companiesState[data.companyId];
    this.updateSSP.emit(data.status);
  }

  protected onEndpointActiveStatusChange(emitData: { side: string; type: string }): void {
    this.updateEndpointActiveStatus.emit(emitData);
  }

  protected onEndpointTableActiveStatusChange(e: number, id: number, side: string) {
    const data = {
      active: Number(e)
    };

    this.mainService.updateEndpointById(id, data, side)
      .subscribe(() => {
        this.updateEndpointActiveStatus.emit({ side: 'ssp', type: 'endpoints' });
      },
        error => {
          this.errorsHandlingService.handleError(error);
        });
  }

  protected onChangeActiveCompany(_: MouseEvent,
    companyId: number,
    type: string,
    company: MainDashboardInterface.ICompaniesDataForMainTable) {
    if (this.authService.userRole === UserRole.viewer) {
      this.viewerRestrictionService.restrictUserViewer();
      return;
    }

    switch (Boolean(company.active)) {
      case true:
        this.mainTableService.onDeactivateCompanyHandler(companyId, type, company, () => this.activateCompany.emit({ side: 'ssp' }));
        break;
      case false:
        this.mainTableService.onActivateCompanyHandler(companyId, type, company, () => this.activateCompany.emit({ side: 'ssp' }));
        break;
    }
  }

  protected onPageIndexChange(pageIndex: number, type: string): void {
    this.paginationState.current_page = pageIndex;
    const data = {
      current_page: this.paginationState.current_page,
      type
    };
    this.changePage.emit(data);
  }

  protected duplicateListEndpoint(data: { endpointId: number, side: string }): void {
    this.duplicatedEndpoint.emit(data);
  }

  protected deleteListEndpoint(data: { endpointId: number, side: string, companyId?: number }): void {
    this.deleteEndpoint.emit(data);
  }
}
